<template>
  <div class="n-search">
    <input
      type="text"
      :placeholder="placeholder"
      :value="value"
      @keyup.enter="handleClick"
      @input="$emit('input', $event.target.value)"
    />
    <i class="input_suffix">
      <el-tooltip content="用图片搜索相似图" placement="bottom" effect="light">
        <svg class="icon" aria-hidden="true" @click="handerImageClick" v-show="showImageUpload" >
          <use xlink:href="#iconyitusoutu"></use>
        </svg>
      </el-tooltip>
      
      <i class="split-line" v-show="showImageUpload"></i>
      <svg class="icon" aria-hidden="true" @click="handleClick">
        <use xlink:href="#iconfangdajing"></use>
      </svg>
    </i>
    <n-modal :show.sync="showUpload" title="用图搜图片" @ok="handleDownload">
      <div class="upload-wrap">
        <el-upload
          show-file-list
          drag
          :action = "upAction"
          :accept = "upAccept"
          :http-request = "httpRequest"
          :before-upload = "beforeUpload"
          :on-preview="handlePreview"
          :on-change="handleFileChange"
          v-if="!onprogress"
          :on-success="handleSuccess"
        >
          <!-- <i class="el-icon-upload"></i> -->
          <div class="el-upload__text">
            <div>
              <p>点击上传图片</p>
              <p>或将文件拖到此处</p>
            </div>
          </div>
        </el-upload>
        <div class="loader__wrap" v-else>
          <div class="loader">
            <div class="loader-inner ball-spin-fade-loader">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        </div>
        <h5 class="upload-tip">JPG格式图片，最大不超过10MB。</h5>
      </div>
    </n-modal>
  </div>
</template>

<script>
export default {
  name: "n-search",
  props: {
    placeholder: {
      default: "请输入关键字",
      type: String,
    },
    value: {
      default: "",
      type: String,
    },
    showImageUpload: {
      default: true,
      type: Boolean,
    },
  },
  model: {
    prop: "value",
    event: "input",
  },
  data() {
    return {
      upAction: "/api/v1/index/search",
      upAccept: 'image/jpeg,image/gif,image/png',
      show: false,
      inputText: "",
      onprogress: false,
      showUpload: false,
    };
  },
  computed: {},
  methods: {
    hideUpload(ishide) {
      //加载效果隐藏
      this.onprogress = false;
      //隐藏文件上传弹窗
      this.showUpload = ishide ? false : true;
    },
    handerImageClick() {
      this.showUpload = true;
    },
    //文字搜索
    handleClick() {
      this.$emit("by-keyword", this.value);
    },
    handleFileChange(file, fileList) {
      //上传中
      if (file.status == 'ready') {
        this.onprogress = true;
      }
    },
    handlePreview(file) {
      this.onprogress = true;
    },
    beforeUpload(file) {
      this.upAccept = this.upAccept.toLowerCase();
      let isImage = this.upAccept.indexOf(file.type.toLowerCase()) >= 0;
      let isSize = file.size / 1024 / 1024 < 10;
      if (!isImage) {
        this.$emit("by-error", '上传文件只能是图片格式['+this.upAccept+']!');
        this.hideUpload();
      } else if (!isSize) {
        this.$emit("by-error", '上传文件大小不能超过 10MB!');
        this.hideUpload();
      }
      return isImage && isSize;
    },
    httpRequest(opt) {
      this.getBase64(opt.file).then(res => {
        this.$emit("by-image", {file: opt.file, base64Data: res});
      });
    },
    handleDownload(){

    },
    handleSuccess(response, file, fileList){
      console.log("handleSuccess", response);
    },
    getBase64(file) {
      return new Promise(function (resolve, reject) {
        let reader = new FileReader();
        let imgResult = "";
        reader.readAsDataURL(file);
        reader.onload = function () {
          imgResult = reader.result;
        };
        reader.onerror = function (error) {
          reject(error);
        };
        reader.onloadend = function () {
          resolve(imgResult);
        };
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.n-search {
  box-sizing: border-box;
  position: relative;

  height: 44px;
  > input {
    box-sizing: border-box;
    pointer-events: none;
    font-size: 18px;
    color: #666666;
    outline: none;
    border: 2px solid #888;
    padding: 8px 16px;
    width: 100%;
    height: 100%;
    border-radius: 22px;
    overflow: hidden;
    text-indent: 20px;
    pointer-events: auto;
    transition: color 0.2s ease;
    &:focus {
      border: 2px solid $primaryColor;
    }
    &:focus + .input_suffix {
      color: $primaryColor;
      transition: color 0.2s ease;
    }
    &:focus + .input_suffix svg {
      color: $primaryColor;
      transition: all 0.2s ease;
    }
    // &:focus + .input_suffix::after {
    //   background-image: url("/galleryimage/scale_o@2x.png");
    // }
  }
  .input_suffix {
    display: inline-block;
    // width: 80px;
    height: 30px;
    font-size: 30px;
    position: absolute;
    top: 50%;
    right: 14px;
    transform: translate(0, -50%);
    z-index: 100;
    cursor: pointer;
    > svg {
      color: $primaryColor;
      vertical-align: top;
    }
    .split-line {
      width: 2px;
      height: 30px;
      background-color: #888;
      display: inline-block;
      margin: 0 8px;
    }
  }
  // .input_suffix::after {
  //   content: "";
  //   width: 100%;
  //   height: 100%;
  //   display: block;
  //   background-image: url(/galleryimage/scale@2x.png);
  //   background-size: 100% 100%;
  //   background-repeat: no-repeat;
  //   transition: all 0.2s ease-in-out;
  //   cursor: pointer;
  //   pointer-events: auto;
  // }
  .upload-wrap {
    display: flex;
    justify-content: center;
    text-align: center;
    flex-direction: column;
    padding-top: 30px;
    .upload-tip {
      text-align: center;
      padding-top: 16px;
      color: #999999;
    }
  }
  .el-upload__text {
    font-size: 28px;
    padding-top: 36px;
    p:nth-child(1) {
      font-size: 28px;
      font-weight: 400;
      color: #333333;
    }
    p:nth-child(2) {
      font-size: 20px;
      font-weight: 400;
      color: #666666;
      margin-top: 40px;
    }
  }
  .upload-wrap .el-upload-dragger {
    border: 1px dashed $primaryColor;
  }
  .el-upload-dragger:hover {
    border-color: $primaryColor;
  }
  .el-upload--picture-card:hover,
  .el-upload:focus {
    border-color: $primaryColor;
  }
  .loader {
    box-sizing: border-box;
    display: flex;
    flex: 0 1 auto;
    flex-direction: column;
    flex-grow: 1;
    flex-shrink: 0;
    flex-basis: 25%;
    max-width: 25%;
    height: 200px;
    align-items: center;
    justify-content: center;
    perspective: 500px;
  }
  .ball-spin-fade-loader > div {
    background-color: $primaryColor;
  }
  .loader__wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: -30px;
  }
}
</style>
